export default __webpack_public_path__ + "e089b4c2dc618e6c5811e04e2eedc15e.png";